import React, { useEffect, useState } from "react";
import Card from "../../components/Card";
import { TRAIT_TYPE_LABEL } from "../../constants/Consts";


export default function TraitCard({ trait, onEdit, onDelete }) {
  const [drink, setDrink] = useState();
  const [category, setCategory] = useState();
  const [attribute, setAttribute] = useState();

  useEffect(() => {
    const getRoot = (trait) => {
      if(!!trait.parent){
        return getRoot(trait.parent);
      } else{
        return trait;
      }
    }

    if(!!trait){
      const parent = getRoot(trait);
      const { attribute } = parent ?? {};
      const { category } = attribute ?? {};
      const { drink } = category ?? {};
      setAttribute(attribute);
      setCategory(category);
      setDrink(drink);
    }
  }, [trait]);

  return (
    <Card
      title={trait.nameBr}
      status={{
        label: trait.enabled ? "Ativo" : "Inativo",
        color: trait.enabled ? "green-400" : "disabled",
      }}
      onEdit={onEdit}
      onDelete={onDelete}
    >
      <p>{`ID: ${trait.id}`}</p>
      <p>{`Ordem: ${trait.order}`}</p>
      { !!drink && <p>{`Bebida: ${drink.nameBr}`}</p> }
      { !!category && <p>{`Categoria: ${category.nameBr}`}</p> }
      { !!attribute && <p>{`Atributo: ${attribute.nameBr}`}</p> }
      <p>{`Tipo: ${TRAIT_TYPE_LABEL[trait.type]}`}</p>
      {(trait.createdByUser && !!trait.user) && <p>{`Autor: ${trait.user.name}`}</p>}
    </Card>
  );
}
